import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { SharedModule } from './../../../shared/shared.module';
import { EditDoctorRoutingModule } from './edit-doctor-routing.module';
import { EditDoctorComponent } from './edit-doctor.component';

@NgModule({
  imports: [CommonModule, NgSelectModule, FormsModule, ReactiveFormsModule, SharedModule, EditDoctorRoutingModule],
  declarations: [EditDoctorComponent]
})
export class EditDoctorModule {}
